import React, { useState } from "react";
import { ContactTag, ContactMaster } from "../types";
import { Autocomplete, TextField } from "@mui/material";
import styled from "@emotion/styled";
import { Dropdown } from "semantic-ui-react";
import {
    addTagToContact,
    removeTagFromContact,
    createEmptyTag,
} from "../firebase";
import { connect } from "react-redux";
import { RootState } from "../redux/root-store";

const EditTextField = styled(TextField)`
    & input {
        padding: 0;
    }
`;

export const StyledDropdown = styled(Dropdown)`
    & span.sizer {
        display: none;
    }

    & a.ui.label {
        border: 1px solid #000;
        background: transparent;
        color: #000;
        font-weight: normal;
        padding: 0;
    }
`;

type EditTag = ContactTag & {
    saveTimeout?: number;
};

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

interface Props extends ReturnType<typeof mapStateToProps> {
    tags: ContactTag[];
    allTags: ContactTag[];
    contact: ContactMaster;
    closeEditTags: () => void;
}

const EditTags = (props: Props) => {
    const [tags, setTags] = useState<ContactTag[]>(props.tags);
    return (
        <StyledDropdown
            options={props.allTags.map((tag: ContactTag) => ({
                key: tag.tag_id,
                text: tag.description,
                value: tag.tag_id,
            }))}
            value={props.tags.map((tag: ContactTag) => tag.tag_id)}
            multiple
            allowAdditions
            search
            defaultOpen
            onClose={() => props.closeEditTags()}
            fluid
            placeholder={"Add groups"}
            onChange={(evt: React.SyntheticEvent, data: any) => {
                if (!props.loggedUser) return;
                if (data.value.length < props.tags.length) {
                    const deletedTag = props.tags.find(
                        (tag: ContactTag) =>
                            data.value.find((t: string) => tag.tag_id === t) ===
                            undefined
                    );
                    if (!deletedTag) return;
                    removeTagFromContact(
                        deletedTag.tag_id,
                        props.contact.contact_id,
                        props.loggedUser.user_id
                    );
                } else {
                    const addedTag = data.value.find(
                        (t: string) =>
                            props.tags.find(
                                (tag: ContactTag) => tag.tag_id === t
                            ) === undefined
                    );
                    if (props.allTags.find((tag) => tag.tag_id === addedTag)) {
                        // add the tag only if it already exists in this list
                        // otherwise the tag will be created by the onAddItem function
                        addTagToContact(
                            addedTag,
                            props.contact.contact_id,
                            props.loggedUser.user_id
                        );
                    }
                }
            }}
            onAddItem={async (evt: React.SyntheticEvent, data: any) => {
                if (!props.loggedUser) return;
                const tag = await createEmptyTag(
                    data.value,
                    props.loggedUser.user_id
                );
                await addTagToContact(
                    tag.tag_id,
                    props.contact.contact_id,
                    props.loggedUser.user_id
                );
            }}
        />
    );
};

export default connect(mapStateToProps, {})(EditTags);
